import { render, staticRenderFns } from "./SchaefflerHeader.vue?vue&type=template&id=2678276e&scoped=true"
import script from "./SchaefflerHeader.vue?vue&type=script&lang=js"
export * from "./SchaefflerHeader.vue?vue&type=script&lang=js"
import style0 from "./SchaefflerHeader.vue?vue&type=style&index=0&id=2678276e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678276e",
  null
  
)

export default component.exports